import { Component, Input } from '@angular/core';
import { CVLocalizationService } from '../services/cv-localization.service';
import { ModuleManagerMetricInfo } from '../../../shared/models/module-manager/module-manager-settings.models';
import { Subscription } from 'rxjs';
import SlideoutSettingsManager from '../../../shared/models/slideout-settings-manager';

@Component({
  selector: 'cv-wallboard-column-sort-selector',
  templateUrl: './wallboard-column-sort-selector.component.html',
  styleUrl: './wallboard-column-sort-selector.component.scss'
})
export class WallboardColumnSortSelectorComponent {
    @Input() settingsManager: SlideoutSettingsManager
    @Input() selectedMetrics: ModuleManagerMetricInfo[];
    @Input() selectedColumn: number;

    columnOptions: (string | number)[][] = [];

    private sortOptions = [true, false, null];
    private subscriptions: Subscription[] = [];
    constructor(
        private localizationService: CVLocalizationService,
    ) { }
    async ngOnInit() {
        await this.localizationService.GetSection('Wallboard_Slideout');

        this.updateOptions();
        this.subscriptions.push(this.settingsManager.managerViewByUpdated.subscribe(_ => this.updateOptions()));
        this.subscriptions.push(this.settingsManager.selectedMetricsChanged.subscribe(_ => this.updateOptions()));
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s?.unsubscribe());
    }

    updateOptions() {
        this.columnOptions = [];

        this.columnOptions.push([this.settingsManager.selectedLevelName, 0]);
        this.selectedMetrics.map((metric) => {
            const option = [metric.CustomName ? metric.CustomName + "*" : metric.Name, metric.Id]
            this.columnOptions.push(option);
        });
    }

    handleSortClick() {
        const curIndex = this.sortOptions.indexOf(this.settingsManager.wallboardColumnSortSettings.SortAscending);
        const newIndex = curIndex + 1 >= this.sortOptions.length ? 0 : curIndex + 1;
        this.settingsManager.wallboardColumnSortSettings.SortAscending = this.sortOptions[newIndex];
    }
}
